import type { UseFormReturn } from 'react-hook-form';
import { Labeled, TextInputField } from '@sixui/ui';
import { useTranslation } from 'react-i18next';

import type { IContainerProps } from '~/components/utils/Container';
import type { IFormMode } from '~/helpers/types';
import type { IArticleFormValues } from './ArticleForm';
import { FormCheckableDisclosure } from '~/components/atoms/fields/CheckableDisclosure';
import { FormField } from '~/components/atoms/FormField';
import { FormFileUploader } from '~/components/organisms/fields/FileUploader';

export type IArticleFormDocumentsSectionProps = IContainerProps & {
  mode: IFormMode;
  form: UseFormReturn<IArticleFormValues>;
  appId: string;
};

export const ArticleFormDocumentsSection: React.FC<
  IArticleFormDocumentsSectionProps
> = ({ sx, form, appId }) => {
  const { t } = useTranslation();
  return (
    <FormCheckableDisclosure
      sx={sx}
      label={t('ArticleFormDocumentsSection.pdf-documents')}
      control={form.control}
      name="documentsEnabled"
      initiallyExpanded={form.watch('documentsEnabled')}
    >
      <FormFileUploader
        appId={appId}
        control={form.control}
        name="documents"
        rules={{ required: true }}
        acceptTypes={['document']}
        disabled={!form.watch('documentsEnabled')}
      />
      <Labeled
        label={t('ArticleFormActionButtonSection.label')}
        disabled={!form.watch('documentsEnabled')}
      >
        <FormField
          name="documentsButtonLabel"
          control={form.control}
          as={TextInputField}
          forwardError
        />
      </Labeled>
    </FormCheckableDisclosure>
  );
};
